import { motion } from "framer-motion";
import { VERTICALS } from "../lib/data";

export default function Verticals() {
  return (
    <section id="verticals" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <span className="em-tag">03 — Verticals</span>
            <h2
              className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
              style={{ fontSize: "clamp(1.8rem, 3.4vw, 3.2rem)" }}
            >
              Where we play.
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed max-w-sm text-sm md:text-base">
              Five arenas we obsess over. Every project we take on lives inside — or bridges — these worlds.
            </p>
          </div>

          <ul className="col-span-12 md:col-span-8 divide-y divide-white/10 border-y border-white/10">
            {VERTICALS.map((v, i) => (
              <motion.li
                key={v.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                className="group grid grid-cols-12 items-center py-5 md:py-7 cursor-pointer"
              >
                <span className="col-span-2 md:col-span-1 font-mono-em text-white/40 text-xs tracking-widest">
                  {v.n}
                </span>
                <span
                  className="col-span-8 md:col-span-9 font-display font-bold tracking-tight leading-none transition-transform duration-500 group-hover:translate-x-2"
                  style={{ fontSize: "clamp(1.2rem, 2vw, 1.9rem)" }}
                >
                  {v.label}
                </span>
                <span className="col-span-2 justify-self-end font-mono-em text-white/50 text-xs tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  →
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
